export const accettaRichiestaServizioEnte = [
  '',
  `mutation AccettaRichiestaServizioCittadino($datiUpdate: DatiRichiestaServizioEnte) {
    AccettaRichiestaServizioCittadino(datiUpdate: $datiUpdate)
  }`,
  'AccettaRichiestaServizioCittadino',
];
